const CONTAINER = 'start-loader-container';
const LOGO = 'start-LoadingIndicator-logo';
const DEFAULT_LOGO = '/logo-white.png';

// Read by the inline script in index.html, which picks the splash logo before
// React (or auth) is up. Keep both in sync.
export const SPLASH_ORGANIZATION_KEY = 'splashOrganizationId';

// The splash background is dark, so ask for the dark variant; the API falls
// back to the light one and 404s when the organization has no custom logo.
export const buildOrganizationLogoUrl = (organizationId: string) =>
  `${import.meta.env.VITE_BASE_API_URL ?? ''}/organizations/${organizationId}/logo/dark`;

export const showStartLoader = () => {
  const loader = document.getElementById(CONTAINER);

  if (loader) {
    loader.style.display = 'block';
  }
};

export const hideStartLoader = ({ isAuthenticated }: { isAuthenticated?: boolean }) => {
  const loader = document.getElementById(CONTAINER);

  if (loader && isAuthenticated !== false) {
    loader.style.display = 'none';
  }
};

export const setStartLoaderOrganization = (organizationId?: string) => {
  const logo = document.getElementById(LOGO) as HTMLImageElement | null;
  if (!logo) return;

  // Compare the org rather than src: a failed custom logo has already fallen back
  // to the default src, and retrying it would only flash the image again.
  if ((logo.dataset.organizationId ?? '') === (organizationId ?? '')) return;
  logo.dataset.organizationId = organizationId ?? '';

  const src = organizationId ? buildOrganizationLogoUrl(organizationId) : DEFAULT_LOGO;

  // Hidden until loaded so the previous logo doesn't linger or a broken image flash.
  logo.style.visibility = 'hidden';
  logo.onload = () => {
    logo.style.visibility = 'visible';
  };
  logo.onerror = () => {
    logo.onerror = null;
    logo.src = DEFAULT_LOGO;
  };
  logo.src = src;
};

export const persistSplashOrganization = (organizationId: string) => {
  try {
    localStorage.setItem(SPLASH_ORGANIZATION_KEY, organizationId);
  } catch {
    // Storage unavailable (private mode / blocked): the splash keeps the default logo.
  }
};

export const clearSplashOrganization = () => {
  try {
    localStorage.removeItem(SPLASH_ORGANIZATION_KEY);
  } catch {
    // Nothing persisted if storage is unavailable.
  }
};
